<i18n>
{
  "de": {
    "whatWeOffer": "die Fan-Plattform",
    "aboutUs": "Über uns",
    "faqs": "FAQs",
    "termsOfUse": "Nutzungsbedingungen",
    "privacyPolicy": "Datenschutz",
    "blog": "Blog",
    "imprint": "Impressum",
    "artistSignup": "Künstler/-innen-Anmeldung",
    "fansAndFortuneGmbH": "Fans & Fortune GmbH"
  },
  "en": {
    "whatWeOffer": "the fan platform",
    "aboutUs": "About us",
    "faqs": "FAQs",
    "termsOfUse": "Terms & Conditions",
    "privacyPolicy": "Privacy Policy",
    "blog": "Blog",
    "imprint": "Imprint",
    "artistSignup": "Artist Signup",
    "fansAndFortuneGmbH": "Fans & Fortune GmbH"
  }
}
</i18n>

<template lang="html">
  <footer
    class="footer"
    :class="footerClasses"
  >
    <!-- Floating Toggle Button (Collapsed State) - Only show on artist pages -->
    <div
      v-if="shouldBeCollapsible"
      class="footer-toggle"
      :class="{ 'footer-toggle--hidden': isExpanded }"
      @click="toggleFooter"
    >
      <div class="logo-wrapper">
        <img
          src="/img/logo_getnext_25_11_18_3.svg"
          alt="getnext logo"
        >
      </div>
    </div>
    <!-- Footer Content (Expanded State) -->
    <div
      class="footer-content"
      :class="{ 'footer-content--visible': isExpanded }"
    >
      <div class="container">
        <div class="columns">
          <div class="column is-half">
            <div class="content">
              <p class="has-text-grey-light">
                getnext - {{ $t('whatWeOffer') }}<br>
                <nuxt-link :to="localePath({ name: 'portal-static-about' })">
                  {{ $t('aboutUs') }}
                </nuxt-link>
              </p>
            </div>
          </div>
          <div class="column">
            <div class="content">
              <nuxt-link :to="localePath({ name: 'portal-static-faq' })">
                {{ $t('faqs') }}
              </nuxt-link><br>
              <nuxt-link :to="localePath({ name: 'portal-static-policy' })">
                {{ $t('termsOfUse') }}
              </nuxt-link><br>
              <nuxt-link :to="localePath({ name: 'portal-static-data-protection' })">
                {{ $t('privacyPolicy') }}
              </nuxt-link><br>
            </div>
          </div>
          <div class="column">
            <div class="content">
              <nuxt-link :to="localePath({ name: 'portal-blog' })">
                {{ $t('blog') }}
              </nuxt-link><br>
              <nuxt-link :to="localePath({ name: 'portal-static-imprint' })">
                {{ $t('imprint') }}
              </nuxt-link><br>
              <nuxt-link :to="localePath({ name: 'portal-static-signup-as-artist' })">
                {{ $t('artistSignup') }}
              </nuxt-link><br>
            </div>
          </div>
        </div>
        <nav class="level">
          <div class="level-left is-flex is-flex-direction-column">
            <a
              href="/"
              class="mb-3"
              @click.prevent="toggleFooter"
            >
              <div class="logo-wrapper">
                <img
                  src="/img/logo_getnext_25_11_18_3.svg"
                  alt="getnext logo"
                >
              </div>
            </a>
            <div class="level-item is-size-7">
              © {{ (new Date(Date.now())).getFullYear() }} {{ $t('fansAndFortuneGmbH') }}
            </div>
          </div>
          <div class="level-right">
            <div class="level-item is-size-7" />
          </div>
        </nav>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'MainFooter',
  data() {
    return {
      isExpanded: false
    }
  },
  computed: {
    isArtistPage() {
      // Check if current route is an artist page (routes with path /:id)
      return this.$route.name && this.$route.name.startsWith('id')
    },
    shouldBeCollapsible() {
      return this.isArtistPage
    },
    footerClasses() {
      if (!this.shouldBeCollapsible) {
        return 'footer--always-visible'
      }
      return {
        'footer--expanded': this.isExpanded,
        'footer--collapsed': !this.isExpanded
      }
    }
  },
  methods: {
    toggleFooter() {
      if (this.shouldBeCollapsible) {
        this.isExpanded = !this.isExpanded
      }
    }
  },
  mounted() {
    // On non-artist pages, footer should always be expanded
    if (!this.shouldBeCollapsible) {
      this.isExpanded = true
    }
  },
  watch: {
    '$route'() {
      // Reset state when route changes
      if (!this.shouldBeCollapsible) {
        this.isExpanded = true
      } else {
        this.isExpanded = false
      }
    }
  }
}
</script>
